import React, { useEffect, useMemo } from 'react';
import { numberToChinese } from '@/utils';
import { storagePrefixV2 } from '@/constant';
import { setCurrentStep, setNextBtnConfig, setPrevBtnConfig, useAIDiagnoseStore } from '../../store/useAIDiagnoseStore';
import { genStepsBySelectTherapyList, THERAPY_TYPE_2_STEP, THERAPY_TYPE_2_TEXT } from '../../utils';

import cx from './index.module.scss';

interface Props {}

const NUMBER_CHARACTERS = ['零', '一', '两', '三', '四', '五', '六', '七', '八', '九'];

const THERAPY_TYPE_2_TIPS: Partial<Record<AIDiagnose.TherapyType, string>> = {
  bodyAdjust: '良好的体态有助于增强自信、改善肌肉平衡性',
  painRelief: '痛症舒缓不仅可以直接减轻疼痛，还能提升您的整体生活质量',
  physicalImprove: '调理体质，可以减少慢性疾病风险',
};

const THERAPY_TYPE_2_EXTRA_CONFIG: Partial<
  Record<
    AIDiagnose.TherapyType,
    {
      title: string;
      bgUrl: string;
    }
  >
> = {
  bodyAdjust: {
    title: '体态',
    bgUrl: storagePrefixV2 + '/ai-consulation/aaqaasdasdq.png',
  },
  painRelief: {
    title: '疼痛',
    bgUrl: storagePrefixV2 + '/ai-consulation/asdoaskjfasf.png',
  },
  physicalImprove: {
    title: '体质',
    bgUrl: storagePrefixV2 + '/ai-consulation/adofmvndhsf.png',
  },
};

export const TransitionPage: React.FC<Props> = () => {
  const currentStep = useAIDiagnoseStore.use.currentStep();
  const { selectTherapyType } = useAIDiagnoseStore.use.formValue();

  const steps = useMemo(() => genStepsBySelectTherapyList(selectTherapyType), [selectTherapyType]);

  const therapyTypeKey = useMemo(
    () => (type: 'prev' | 'next') =>
      Object.keys(THERAPY_TYPE_2_STEP).find(item =>
        THERAPY_TYPE_2_STEP[item]?.includes(steps[type === 'prev' ? currentStep - 1 : currentStep + 1])
      ) as AIDiagnose.TherapyType,
    [currentStep, steps]
  );

  useEffect(() => {
    setPrevBtnConfig({ show: false });

    setNextBtnConfig({
      disable: false,
      action: () => {
        setCurrentStep(prev => ({ currentStep: prev + 1 }));
      },
    });
  }, []);

  return (
    <div className={cx('TransitionPage')}>
      <div className={cx('content')}>
        <div className={cx('step-tips')}>
          <div className={cx('current-step-tips')}>已收到您的{THERAPY_TYPE_2_TEXT[therapyTypeKey('prev')]}诉求</div>
          <div className={cx('next-step-tips')}>
            <div>
              {therapyTypeKey('next') === 'physicalImprove' ? '最后' : '接下来只需'}
              {numberToChinese(THERAPY_TYPE_2_STEP[therapyTypeKey('next')]?.length, NUMBER_CHARACTERS)}步
            </div>
            <div>让我们了解您的{THERAPY_TYPE_2_EXTRA_CONFIG[therapyTypeKey('next')]?.title}情况</div>
          </div>
        </div>
        <div className={cx('plan-tips')}>{THERAPY_TYPE_2_TIPS[therapyTypeKey('next')]}</div>
      </div>
      <div
        className={cx('mirror-bg')}
        style={{ backgroundImage: `url(${THERAPY_TYPE_2_EXTRA_CONFIG[therapyTypeKey('next')]?.bgUrl})` }}
      />
    </div>
  );
};
